import { FormBuilder } from '@angular/forms';
import { Component } from '@angular/core';
import { NavController, NavParams, ModalController, ToastController } from 'ionic-angular';
import { AngularFirestore } from 'angularfire2/firestore';
import { AngularFireAuth } from 'angularfire2/auth';
import { LoadingProvider } from '../../providers/loading/loading';
import { Http } from '@angular/http';

@Component({
  selector: 'page-history-details',
  templateUrl: 'history-details.html',
})
export class HistoryDetailsPage {
  public header_title: any;
  public contact_uid: any;
  public document_id: any;
  public user_history: any;
  public SDF_form: any;
  public users: any;
  public firstname: any;
  public lastname: any;

  constructor(
    public navCtrl: NavController, 
    public navParams: NavParams, 
    public formBuilder: FormBuilder, 
    public afs: AngularFirestore, 
    public modalCtrl: ModalController, 
    public afAuth:AngularFireAuth, 
    public toastCtrl: ToastController,
    public loadingProvider: LoadingProvider,
    public http: Http,
    public db: AngularFirestore
  ) {
    this.header_title = "Changed Details";
    this.document_id = this.navParams.get("document_id");
    this.SDF_form = this.navParams.get("SDF_form_document_id");
    this.users = [];
    console.log(this.document_id)
    this.getAllRelatedUsers().subscribe((data)=>{
      console.log(data)
      data.forEach(uData => {
        if(uData.contact_type == "Primary Contact"){
          this.firstname = uData.firstname;
          this.lastname = uData.lastname;
        }else{
          this.users.push({'firstname': uData.firstname, 'lastname': uData.lastname});
        }
      })
      this.getAllChangedDetails().subscribe((data)=>{
        console.log(data)
        console.log('this.users', this.users)
        this.user_history = data
      });
    });

  }

  getAllChangedDetails (){
    return this.db.collection<any>( "user_history" , ref => ref.where('document_id','==',this.document_id )).valueChanges ();
  }

  getAllRelatedUsers (){
    return this.db.collection<any>( "users_data" , ref => ref.where('created_date','>',0 ).where('SDF_form_document_id','==',this.SDF_form ).where('deleted','==',0 ).orderBy('created_date', 'asc')).valueChanges ();
  }


  ionViewDidLoad() {
    console.log('ionViewDidLoad HistoryDetailsPage');
  }

  public closeModal(){
    this.navCtrl.pop();
  }

}



// WEBPACK FOOTER //
// ./src/pages/history-details/history-details.ts